import { CustomPage2 } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import unionBy from '../unionBy'
import { buildCanonicalPage } from './buildCanonicalPage'
import { getPagesWithCanonicals } from './getPagesWithCanonicals'
import { queryParamsRemoval } from './queryParamsRemoval'
import { removeExternals } from './removeExternals'

interface IProps {
  customPages?: CustomPage2[] | undefined
}
const getCustomPagesScenesConfig = ({ customPages }: IProps) => {
  const customPagesConfig = customPages || []
  const curatedPages = customPagesConfig.filter(removeExternals)
  const canonicalPages = customPagesConfig
    .filter(getPagesWithCanonicals)
    .map(buildCanonicalPage)
  const parsedPages = [...curatedPages, ...canonicalPages].map(
    ({ link, name, params }) => ({
      name,
      urlName: queryParamsRemoval(link?.path),
      redirect: link?.redirect,
      params,
      canonical: link?.canonical,
    })
  )

  return unionBy(parsedPages, 'urlName')
}

export default getCustomPagesScenesConfig
